import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const ListParagraphDotsCheckmark = (
  props: MyIconProps,
): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M12 12h8M12 19h8M12 5h8M4.8 4.8 6.001 6 8 4M6.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 19a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
    </svg>
  );
};
